// 사용자/담당자와 관리자 모두 같은 입과 오류를 업무 문구로 안내한다.
export const enrollmentMessages = {
  ENROLLMENT_EXPORT_REASON_REQUIRED: 'CSV 내보내기 사유는 줄바꿈 없이 500자 이내로 입력해 주세요.',
  INVALID_ENROLLMENT_EXPORT_FILTER: 'CSV 검색어와 등록 상태를 확인해 주세요.',
  ENROLLMENT_EXPORT_DENIED: '수강 CSV 내보내기 권한이 없거나 기업 소속이 종료되었습니다. 소속을 다시 확인해 주세요.',
  ENROLLMENT_EXPORT_TOO_LARGE: '전체 결과가 내보내기 한도를 초과했습니다. 검색 조건을 좁혀 다시 요청해 주세요. 일부 결과만 내려받지는 않습니다.',
  INVALID_LEARNING_INPUT: '학습 요청을 확인할 수 없습니다. 화면을 다시 열어 주세요.',
  LEARNING_LAUNCH_EXPIRED: '학습 시작 대기시간이 지났습니다. 다시 시작해 주세요.',
  LEARNING_SESSION_CLOSED: '학습이 종료되었습니다. 저장된 진도를 확인하고 다시 시작해 주세요.',
  LEARNING_CONTENT_REPLACED: '관리자가 이 차시의 콘텐츠를 교체했습니다. 저장된 진도를 확인한 뒤 다시 시작해 주세요.',
  LEARNING_SESSION_EXPIRED: '학습 연결이 오래 끊겨 종료되었습니다. 다시 시작해 주세요.',
  SESSION_TAKEOVER_REAUTH_REQUIRED: '다른 학습창이 열려 있습니다. 이 창에서 계속하려면 새 본인인증이 필요합니다. 인증 전까지 기존 창은 유지됩니다.',
  SESSION_EVICTED: '다른 기기에서 학습이 시작되어 이 학습창이 종료되었습니다.',
  LEARNING_REQUEST_CONFLICT: '재전송한 학습 내용이 달라 저장하지 않았습니다. 학습창을 다시 열어 주세요.',
  LEARNING_SEQUENCE_CONFLICT: '학습 저장 순서를 확인할 수 없습니다. 학습창을 다시 열어 주세요.',
  LEARNING_CONTENT_UNSUPPORTED: '이 콘텐츠의 학습 재생 연결은 준비 중입니다. 교육 운영 담당자에게 문의해 주세요.',
  LEARNING_POLICY_UNSUPPORTED: '이전 진도 정책은 운영 검토가 필요합니다. 교육 운영 담당자에게 문의해 주세요.',
  LEARNING_PROGRESS_REVIEW_REQUIRED: '저장된 진도 확인이 필요합니다. 교육 운영 담당자에게 문의해 주세요.',
  LEARNING_TAKEOVER_EXPIRED: '학습창 전환 요청의 유효시간이 지났습니다. 학습 시작부터 다시 진행해 주세요.',
  LEARNING_TAKEOVER_STALE: '기존 학습창 상태가 바뀌었습니다. 학습 정보를 확인한 뒤 다시 시작해 주세요.',
  LEARNING_SCOPE_DENIED: '본인 수강과 접근 가능한 차시인지 확인해 주세요.',
  LEARNING_ENROLLMENT_INACTIVE: '현재 수강 상태에서는 학습할 수 없습니다.',
  LEARNING_NOT_STARTED: '아직 학습 시작일이 되지 않았습니다.',
  LEARNING_PERIOD_ENDED: '학습기간이 종료되었습니다.',
  LEARNING_SEQUENCE_REQUIRED: '순차학습 과정입니다. 이전 차시를 모두 완료해야 이 차시를 학습할 수 있습니다.',
  LEARNING_NOTE_INVALID: '학습노트는 1자 이상 5,000자 이하로 입력해 주세요.',
  LEARNING_REVIEW_UNAVAILABLE: '복습기간(학습 종료일 다음 날부터 1개월)에만 복습할 수 있습니다. 복습기간이 지났거나 수강 상태를 확인해 주세요.',
  LEARNING_REVIEW_REQUIRED: '복습 화면을 다시 열어 주세요. 재생 확인 시간이 지났습니다.',
  LEARNING_OPENING_UNAVAILABLE: '현재 이 개설에서 학습할 수 없습니다. 운영 담당자에게 확인해 주세요.',
  LEARNING_SNAPSHOT_INVALID: '수강 기준 정보를 확인해야 합니다. 운영 담당자에게 문의해 주세요.',
  IDENTITY_POLICY_INVALID: '본인인증 정책을 확인해야 합니다. 운영 담당자에게 문의해 주세요.',
  IDENTITY_ITEM_REQUIRED: '차시별 인증이 필요한 과정입니다. 학습할 차시를 먼저 선택해야 합니다.',
  IDENTITY_POINT_INVALID: '해당 학습 인증 조건을 조회할 수 없습니다.',
  REAUTH_REQUIRED: '현재 학습 목적의 본인인증이 필요합니다.',
  BULK_INPUT_INVALID: '파일·개설·선택 행과 사유(500자 이내)를 확인해 주세요.',
  BULK_LIMIT_REQUIRED: '일괄 처리 용량이 설정되지 않았습니다. 운영 담당자에게 확인해 주세요.',
  BULK_ROW_LIMIT: '파일의 행 수가 허용 범위를 벗어났습니다. 파일을 나누어 검증해 주세요.',
  BULK_CONFIRM_LIMIT: '선택한 인원이 한 번에 확정할 수 있는 수를 초과했습니다.',
  BULK_FILE_LIMIT: '파일이 현재 허용 용량을 초과했습니다.',
  BULK_FILE_CHANGED: '검증 이후 파일이 변경되었습니다. 파일을 다시 검증해 주세요.',
  BULK_REVALIDATE_REQUIRED: '검증 이후 소속·개설·정책 정보가 변경되었습니다. 새 검증 작업을 만들어 주세요.',
  BULK_SCOPE_DENIED: '이 일괄 작업을 처리할 권한이 없습니다. 현재 계정·연수원·기업 소속을 확인해 주세요.',
  BULK_MEMBER_UNAVAILABLE: '이 기업의 현재 소속 회원인지 확인해 주세요.',
  BULK_PENDING_APPLICATION: '대기 중인 신청이 있습니다. 신청 내역에서 먼저 검토해 주세요.',
  BULK_DUPLICATE_MEMBER: '파일 안에 같은 회원이 두 번 있습니다.',
  BULK_MEMBER_KEY_INVALID: '회원 아이디 하나를 공백·수식 없이 입력해 주세요.',
  BULK_TEXT_CELL_REQUIRED: 'Excel 회원 아이디를 텍스트 형식으로 입력해 주세요. 숫자값은 추정하지 않습니다.',
  BULK_FORMULA_FORBIDDEN: '수식 셀을 사용할 수 없습니다. 회원 아이디 원문을 입력해 주세요.',
  BULK_COLUMNS_INVALID: '회원 아이디 열 하나만 사용해 주세요.',
  BULK_HEADER_INVALID: '파일 첫 행은 MBER_ID 열 하나여야 합니다.',
  BULK_SINGLE_SHEET_REQUIRED: 'Excel 파일에는 시트 하나만 포함해 주세요.',
  BULK_FILE_TYPE_INVALID: 'UTF-8 CSV 또는 XLSX 파일을 선택해 주세요.',
  BULK_FILE_INVALID: '파일 형식을 읽을 수 없습니다. 내용을 확인한 뒤 새 파일로 저장해 주세요.',
  BULK_SELECTION_INVALID: '중복 없이 검증을 통과한 행만 선택해 주세요.',
  BULK_VERSION_CONFLICT: '다른 곳에서 작업 상태를 변경했습니다. 최신 결과를 다시 확인해 주세요.',
  BULK_REQUEST_CONFLICT: '이미 처리한 요청과 내용이 다릅니다. 작업 결과를 다시 확인해 주세요.',
  BULK_NOT_FOUND: '일괄 작업을 찾을 수 없습니다. 목록을 다시 확인해 주세요.',
  APPLICATION_INPUT_INVALID: '신청 대상·개설·처리 사유를 확인해 주세요.',
  APPLICATION_SCOPE_DENIED: '이 신청 업무를 처리할 권한이 없습니다. 현재 계정과 기업 소속을 확인해 주세요.',
  APPLICATION_NOT_FOUND: '신청 내역을 찾을 수 없습니다. 목록을 다시 확인해 주세요.',
  APPLICATION_REQUEST_CONFLICT: '이 요청은 다른 신청 처리에 사용되었습니다. 내용을 다시 확인해 주세요.',
  APPLICATION_ALREADY_EXISTS: '이 과정에 대기 중이거나 승인된 신청이 있습니다. 신청 내역을 확인해 주세요.',
  APPLICATION_INDIVIDUAL_UNAVAILABLE: '이 과정은 개별 수강신청을 받지 않습니다. 소속 기업 교육담당자에게 문의해 주세요.',
  APPLICATION_ALREADY_STUDYING: '이미 학습 중인 과정입니다. 나의강의실 진행중인 과정에서 확인해 주세요.',
  APPLICATION_PERIOD_ADMIN_REQUIRED: '개별 수강신청은 운영기관 관리자가 학습기간을 정해 승인합니다.',
  APPLICATION_PERIOD_INVALID: '학습 시작일과 종료일을 확인해 주세요. 종료일은 시작일과 오늘 이후여야 합니다.',
  APPLICATION_REAPPLY_REQUIRED: '신청 이후 소속이나 개설 정보가 변경되었습니다. 기존 신청을 정리한 뒤 다시 신청해 주세요.',
  APPLICATION_VERSION_CONFLICT: '다른 곳에서 신청을 처리했습니다. 목록과 상세를 다시 확인해 주세요.',
  APPLICATION_TRANSITION_DENIED: '대기 중인 신청만 처리할 수 있습니다. 현재 상태를 확인해 주세요.',
  ENROLLMENT_INPUT_INVALID: '강좌·학습기간·업체·회원 아이디와 처리 사유(500자 이내)를 확인해 주세요.',
  ENROLLMENT_SCOPE_DENIED: '이 수강 업무의 권한이 없거나 기업 소속이 변경되었습니다. 소속과 연수원을 다시 확인해 주세요.',
  ENROLLMENT_NOT_FOUND: '수강 내역을 찾을 수 없습니다. 목록을 다시 확인해 주세요.',
  ENROLLMENT_MEMBER_UNAVAILABLE: '사용 중인 학습자 또는 교육담당자 회원인지 확인해 주세요.',
  ENROLLMENT_MEMBERSHIP_REQUIRED: '회원 아이디를 확인해 주세요. 오늘 기준으로 이 기업 소속인 회원만 처리할 수 있습니다.',
  ENROLLMENT_REQUEST_CONFLICT: '이미 처리된 요청과 내용이 다릅니다. 수강 내역을 다시 확인해 주세요.',
  ENROLLMENT_ALREADY_ENROLLED: '같은 회원이 이미 이 개설에 등록되어 있습니다. 취소한 수강도 같은 차수에 다시 등록할 수 없습니다.',
  ENROLLMENT_LEGACY_REVIEW_REQUIRED: '이전 수강의 등록 근거를 먼저 확인해야 합니다. 운영 담당자에게 문의해 주세요.',
  ENROLLMENT_VERSION_CONFLICT: '수강 상태가 먼저 변경되었습니다. 입력한 사유는 유지했습니다. 창을 닫고 선택 수강을 다시 확인해 주세요.',
  ENROLLMENT_TRANSITION_DENIED: '현재 수강 상태에서는 처리할 수 없습니다. 선택 수강을 다시 확인해 주세요.',
  OPENING_VERSION_CONFLICT: '개설이 변경되었습니다. 입력한 회원과 사유는 유지했습니다. 개설·연수원을 다시 선택해 주세요.',
  OPENING_TRANSITION_DENIED: '현재 공개된 개설만 입과할 수 있습니다. 개설 상태를 확인해 주세요.',
  OPENING_ALREADY_ENROLLED: '같은 회원이 이미 이 개설에 등록되어 있습니다. 다른 차수의 재수강은 별도로 등록합니다.',
  OPENING_CONTRACT_NOT_CONFIRMED: '위탁계약이 확정 상태인지 확인해 주세요. 철회·취소된 계약으로는 등록할 수 없습니다.',
  OPENING_CONTRACT_CHANGED: '위탁계약 문서가 변경되었습니다. 개설과 계약을 다시 확인해 주세요.',
  OPENING_CONTRACT_PERIOD: '위탁계약이 전체 학습기간을 포함해야 합니다.',
  OPENING_CONTRACT_SITE: '선택한 연수원이 위탁계약에 포함되어 있지 않습니다.',
  OPENING_SITE_PERIOD: '연수원의 이용계약 기간을 확인해 주세요.',
  OPENING_COMPANY_DENIED: '이 기업은 해당 개설에 등록할 수 없습니다.',
  ENROLLMENT_COMPANY_UNAVAILABLE: '사용 중인 업체인지 확인해 주세요. 중지·삭제된 업체에는 등록할 수 없습니다.',
  ENROLLMENT_PERIOD_INVALID: '강좌와 학습 시작일·종료일을 확인해 주세요. 종료일은 시작일과 같거나 뒤여야 합니다.',
  ENROLLMENT_PERIOD_ENDED: '이미 끝난 학습기간으로는 등록할 수 없습니다.',
  ENROLLMENT_POLICY_REQUIRED: '이 강좌에 쓸 수 있는 학습 정책이 없습니다. 사용 중인 인정시간 정책(강좌 수료 조건의 본인인증 여부와 일치)을 확인해 주세요.',
  ENROLLMENT_BATCH_LIMIT: '한 번에 500명까지 등록할 수 있습니다. 나누어 등록해 주세요.',
  OPENING_ITEMS_REQUIRED: '강좌에 사용 중인 차시가 없습니다. 과정 관리에서 목차를 확인해 주세요.',
  BROKEN_CONTENT_REFERENCE: '강좌 목차에 삭제되었거나 연결이 끊긴 과정·모듈이 있습니다. 과정 관리에서 확인해 주세요.',
  BROKEN_CONTENT_REVISION: '차시에 연결된 콘텐츠 버전이 삭제되었거나 시간·버전이 맞지 않습니다. 콘텐츠 연결을 확인해 주세요.',
  INVALID_CONTENT_TIME_OR_VERSION: '모든 차시에 학습시간과 콘텐츠 버전이 있어야 합니다. 과정 관리에서 확인해 주세요.',
  OPENING_EXAM_SCORE_MISMATCH: '강좌 수료 조건의 만점과 연결한 시험지 총점이 달라 개설을 만들 수 없습니다. 과정 관리에서 확인해 주세요.',
  OPENING_EXAM_PAPER_UNAVAILABLE: '강좌에 연결한 시험지가 확정 상태가 아니거나 삭제되어 개설을 만들 수 없습니다.',
  OPENING_SURVEY_UNAVAILABLE: '강좌에 연결한 설문이 확정 상태가 아니어서 개설을 만들 수 없습니다.',
  OPENING_SURVEY_TRIGGER_UNAVAILABLE: '설문의 시험 완료 조건에 맞는 시험이 강좌에 연결되어 있지 않습니다.',
  COMPLETION_REQUIRED: '강좌의 수료 기본 조건을 먼저 저장해 주세요.',
  OPENING_PERIOD_ENDED: '학습기간이 종료되어 신규 등록할 수 없습니다.',
  OPENING_MEMBER_UNAVAILABLE: '등록할 회원의 사용 상태를 확인해 주세요.',
  OPENING_PRODUCT_UNAVAILABLE: '사용할 수 없는 강좌입니다. 강좌 상태를 확인해 주세요.',
}
